import IClient, { IUnitClient } from '@/interfaces/client';

export default class ClientModel {
  public id: number;
  public nome: string;
  public nomeFantasia: string;
  public cnpj: string;
  public telefone: string;
  public unidades: IUnitClient[];
  public ativo: boolean;

  public codigoProtheus: string;
  public vendedor: string;
  public supervisor: string;

  public vencimentoContrato: Date;
  public email: string;
  public licitado: string;

  public endereco: any;

  constructor(_initialValues?: IClient) {
    const initialValues = _initialValues || {
      id: null,
      nome: null,
      nomeFantasia: null,
      cnpj: null,
      telefone: null,
      unidades: [],
      ativo: true,

      codigoProtheus: null,
      vendedor: null,
      supervisor: null,
      vencimentoContrato: null,
      email: null,
      licitado: null,
      endereco: null,
      
    };

    this.id = initialValues.id;
    this.nome = initialValues.nome;
    this.nomeFantasia = initialValues.nomeFantasia;
    this.cnpj = initialValues.cnpj;
    this.telefone = initialValues.telefone;
    this.unidades = initialValues.unidades;
    this.ativo = initialValues.ativo;
    
    this.codigoProtheus = initialValues.codigoProtheus;
    this.vendedor = initialValues.vendedor;
    this.supervisor = initialValues.supervisor;
    this.vencimentoContrato = initialValues.vencimentoContrato;
    this.licitado = initialValues.licitado;
    this.email = initialValues.email;
    this.endereco = initialValues.endereco;

  }

  public validate(): boolean {
    return !!this.nome && !!this.cnpj;
  }

  public toJson(): IClient {
    return {
      id: this.id,
      nome: this.nome,
      nomeFantasia: this.nomeFantasia,
      cnpj: this.cnpj,
      telefone: this.telefone,
      ativo: this.ativo,
      codigoProtheus: this.codigoProtheus,
      vendedor: this.vendedor,
      supervisor: this.supervisor,
      vencimentoContrato: this.vencimentoContrato,
      email: this.email,
      licitado: this.licitado,
      endereco: this.endereco,
    };
  }
}
